import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "preact/jsx-runtime";
import { useContext, useMemo, } from 'preact/compat';
import defaultNumberFormat from '@widgets/shared/defaultNumberFormat';
import useCheckoutPrice from '@widgets/GenericBookings/hooks/useCheckoutPrice';
import { getActivities, getSelectedActivities } from '@genericBookings/store/reducers/activities';
import { useAppSelector } from '@genericBookings/store/hooks';
import Styles from './styles';
function Price({ children, options }) {
    const { isBuilder } = useContext(options);
    const activitySelector = isBuilder ? getSelectedActivities : getActivities;
    const activities = useAppSelector(activitySelector);
    const { totalPrice, standardPrice } = useCheckoutPrice(activities);
    // console.log('Total Price: ', totalPrice, ' Standard price: ', standardPrice, ' activities: ', activities);
    const renderPrice = () => {
        if (totalPrice > 0) {
            return _jsx(Styles.Large, { children: `${defaultNumberFormat.format(totalPrice)}` });
        }
        if (totalPrice === standardPrice) {
            return _jsx(Styles.Large, { children: `${defaultNumberFormat.format(totalPrice)}` });
        }
        return (_jsxs(_Fragment, { children: [_jsx(Styles.Large, { children: `${defaultNumberFormat.format(totalPrice)}` }), _jsx(Styles.Small, { children: `${defaultNumberFormat.format(standardPrice)}` })] }));
    };
    const price = useMemo(renderPrice, [totalPrice, standardPrice]);
    if (!price)
        return null;
    return (_jsxs(Styles.Wrapper, { children: [children, _jsx(Styles.Inner, { children: price })] }));
}
export default Price;
